import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * Modal that prompts the admin for a single numeric value (e.g. ETA minutes)
 * before applying a quick-reply template that contains a `{value}` slot.
 */
export default function TemplateInputModal({
  open,
  onOpenChange,
  template,
  value,
  onValueChange,
  onSubmit,
  onCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="template-input-modal">
        <DialogHeader>
          <DialogTitle>{template?.name || "Enter Value"}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <label className="block text-sm font-medium text-zinc-700 mb-2">
            {template?.inputLabel || "Value"}
          </label>
          <input
            type="number"
            min="1"
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
            placeholder={template?.inputPlaceholder || ""}
            className="w-full px-3 py-2 border rounded-lg text-lg focus:outline-none focus:ring-2 focus:ring-[#207024]/20 focus:border-[#207024]"
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                onSubmit();
              }
            }}
            data-testid="template-input-value"
          />
        </div>
        <div className="flex gap-2 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm text-zinc-600 hover:text-zinc-800"
            data-testid="template-input-cancel"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="px-4 py-2 text-sm bg-[#207024] text-white rounded-lg hover:bg-[#1a5c1d]"
            data-testid="template-input-apply"
          >
            Apply
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
